import { shallowMount } from "@vue/test-utils";
import NumberInput from "@/components/core/NumberInput";

describe("NumberInput component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(NumberInput);
  });

  it("Renders del component NumberInput", () => {
    expect(wrapper).toBeDefined();
  });

  it("Debe de establecer el valor por defecto", () => {
    expect(wrapper.text()).toContain("");
  });
});
